/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Worker',dictionary:{"de":{"references":{"person":{"__getters":{"titleName":"Name","lastFirstTitleName":"Name","lastFirstName":"Name","localAddress":"Adresse","internationalAddress":"Adresse"}},"login":"Benutzer","contractualRelationship":"Vertragsverhältnis","division":"Abteilung","operationArea":"Tätigkeitsfeld","drivingLicense":"Führerschein","profession":"Beruf","skillLevel":"Funktion","status":"Status","type":"Art"},"workerId":"Mitarbeiter-ID","general":{"insuranceNumber":"SV-Nummer","contractPeriod":{"start":"Start","end":"Ende"},"education":{"school":"Schule","university":"Universität"}},"__getters":{"professionString":"Beruf","drivingLicenseString":"Führerschein"}},"en":{"references":{"person":{"__getters":{"titleName":"Name","lastFirstTitleName":"Name","lastFirstName":"Name","localAddress":"Address","internationalAddress":"Address"}},"login":"Benutzer","contractualRelationship":"Contractual Relationship","division":"Division","operationArea":"Operation Area","drivingLicense":"Driving license","profession":"Profession","skillLevel":"Skill-Level","status":"Status","type":"Type"},"workerId":"Worker-ID","general":{"insuranceNumber":"Social Insurance Number","contractPeriod":{"start":"Start","end":"End"},"education":{"school":"School","university":"University"}},"__getters":{"professionString":"Profession","drivingLicenseString":"Driving License"}}}})
import { Login } from './Login';
import { Person } from './Person';
import { WorkerContractualRelationship } from './WorkerContractualRelationship';
import { WorkerDivision } from './WorkerDivision';
import { WorkerOperationArea } from './WorkerOperationArea';
import { DrivingLicense } from './DrivingLicense';
import { WorkerProfession } from './WorkerProfession';
import { WorkerSkillLevel } from './WorkerSkillLevel';
import { WorkerStatus } from './WorkerStatus';
import { WorkerType } from './WorkerType';
import { WorkTime } from './WorkTime';
import { Absence } from './Absence';

export class Worker extends _BaseModel {
	
	static toString() {
		return 'Worker'
	}
	
	get __getters() {
		const self = this;
		return {
			get professionString() {
        const professionArray = self.references.profession;
        const professions = professionArray
            .map(function (item) {
                return item.general.name;
            })
            .sort(); //Todo#: performance question?
        // for (var i = 0; i < professionArray.length; i++) {
        //     if (i === professionArray.length - 1) {
        //         professions += professionArray[i].general.name;
        //     } else {
        //         professions += professionArray[i].general.name + ', ';
        //     }
        // }
        return professions.join(', ');
    },
			get drivingLicenseString() {
        const drivingLicenseArray = self.references.drivingLicense;
        const drivingLicenses = drivingLicenseArray
            .map(function (item) {
                return item.general.name;
            })
            .sort(); //Todo#: performance question?

        return drivingLicenses.join(', ');
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Worker.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Worker', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Worker.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Worker', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Worker.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Worker', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Worker.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Worker', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'meta.currentDocument'}) ],
				model: Worker,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Worker', path:'meta.revisions'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	person:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Person'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Worker', path:'references.person'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Person) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.person'}) ],
				model: Person,
				returnObject: true,
},
    
	},
	
					
	login:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.login'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	contractualRelationship:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerContractualRelationship'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerContractualRelationship) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.contractualRelationship'}) ],
				model: WorkerContractualRelationship,
				returnObject: true,
},
    
	},
	
					
	division:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerDivision'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerDivision) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.division'}) ],
				model: WorkerDivision,
				returnObject: true,
},
    
	},
	
					
	operationArea:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerOperationArea'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerOperationArea) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.operationArea'}) ],
				model: WorkerOperationArea,
				returnObject: true,
},
    
	},
	
					
	drivingLicense:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.DrivingLicense'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Worker', path:'references.drivingLicense'}) ],
				model: DrivingLicense,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	profession:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerProfession'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Worker', path:'references.profession'}) ],
				model: WorkerProfession,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	skillLevel:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerSkillLevel'),
				itemText: "general.name",
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Worker', path:'references.skillLevel'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerSkillLevel) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.skillLevel'}) ],
				model: WorkerSkillLevel,
				returnObject: true,
},
    
	},
	
					
	status:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerStatus'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerStatus) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.status'}) ],
				model: WorkerStatus,
				returnObject: true,
},
    
	},
	
					
	type:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerType'),
				itemText: "general.name",
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Worker', path:'references.type'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerType) || _BaseModel.t('rules.reference', {modelName:'Worker', path:'references.type'}) ],
				model: WorkerType,
				returnObject: true,
},
    
	},
	
					
	workTimes:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkTime'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Worker', path:'references.workTimes'}) ],
				model: WorkTime,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	absences:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Absence'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Worker', path:'references.absences'}) ],
				model: Absence,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
				contractPeriod: 					{
						
	start:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Worker.general.contractPeriod.start'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Worker', path:'general.contractPeriod.start'}) ],
},
    __isDate: true,
	},
	
						
	end:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Worker.general.contractPeriod.end'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Worker', path:'general.contractPeriod.end'}) ],
},
    __isDate: true,
	},
	
},
					
	insuranceNumber:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Worker.general.insuranceNumber'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Worker', path:'general.insuranceNumber'}) ],
},
    
	},
	
				education: 					{
						
	school:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Worker.general.education.school'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Worker', path:'general.education.school'}) ],
},
    
	},
	
						
	university:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Worker.general.education.university'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Worker', path:'general.education.university'}) ],
},
    
	},
	
},
},
				
	workerId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Worker.workerId'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Worker', path:'workerId'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Worker._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, general={}, workerId='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.general=GeneralClass.create(general);
		this.workerId=workerId;
		this._id=_id;
	}

	static create(data) {
		return new Worker(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Worker || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Worker.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Worker ? item : Worker.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({person=undefined, login=undefined, contractualRelationship=undefined, division=undefined, operationArea=undefined, drivingLicense=[], profession=[], skillLevel=undefined, status=undefined, type=undefined, workTimes=[], absences=[], }={}){
		this.person= (person instanceof Person || typeof person === 'string' || !person) ? person : Person.create(person);
		this.login= (login instanceof Login || typeof login === 'string' || !login) ? login : Login.create(login);
		this.contractualRelationship= (contractualRelationship instanceof WorkerContractualRelationship || typeof contractualRelationship === 'string' || !contractualRelationship) ? contractualRelationship : WorkerContractualRelationship.create(contractualRelationship);
		this.division= (division instanceof WorkerDivision || typeof division === 'string' || !division) ? division : WorkerDivision.create(division);
		this.operationArea= (operationArea instanceof WorkerOperationArea || typeof operationArea === 'string' || !operationArea) ? operationArea : WorkerOperationArea.create(operationArea);
		if(Array.isArray(drivingLicense)){
			this.drivingLicense=[];
			for(const item of drivingLicense){
				if(typeof item === 'string') this.drivingLicense.push(item)
				else if(typeof item === 'object')
					this.drivingLicense.push(item instanceof DrivingLicense ? item : DrivingLicense.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.drivingLicense=drivingLicense;
		}
		if(Array.isArray(profession)){
			this.profession=[];
			for(const item of profession){
				if(typeof item === 'string') this.profession.push(item)
				else if(typeof item === 'object')
					this.profession.push(item instanceof WorkerProfession ? item : WorkerProfession.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.profession=profession;
		}
		this.skillLevel= (skillLevel instanceof WorkerSkillLevel || typeof skillLevel === 'string' || !skillLevel) ? skillLevel : WorkerSkillLevel.create(skillLevel);
		this.status= (status instanceof WorkerStatus || typeof status === 'string' || !status) ? status : WorkerStatus.create(status);
		this.type= (type instanceof WorkerType || typeof type === 'string' || !type) ? type : WorkerType.create(type);
		if(Array.isArray(workTimes)){
			this.workTimes=[];
			for(const item of workTimes){
				if(typeof item === 'object')
					this.workTimes.push(item instanceof WorkTime ? item : WorkTime.create(item))
				else this.workTimes.push(item)
			}
		} else {
			this.workTimes=workTimes;
		}
		if(Array.isArray(absences)){
			this.absences=[];
			for(const item of absences){
				if(typeof item === 'object')
					this.absences.push(item instanceof Absence ? item : Absence.create(item))
				else this.absences.push(item)
			}
		} else {
			this.absences=absences;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class GeneralClass {
	constructor({contractPeriod={}, insuranceNumber='', education={}, }={}){
		this.contractPeriod=ContractPeriodClass.create(contractPeriod);
		this.insuranceNumber=insuranceNumber;
		this.education=EducationClass.create(education);
	}

	static create(data) {
		return new GeneralClass(data);
	}
}

class ContractPeriodClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new ContractPeriodClass(data);
	}
}

class EducationClass {
	constructor({school='', university='', }={}){
		this.school=school;
		this.university=university;
	}

	static create(data) {
		return new EducationClass(data);
	}
}
